import {PayloadAction} from '@reduxjs/toolkit'
import {
  setSearchProgressPercentage,
  setSearchProgressPercentageIncrementally,
  setSearchProgressPercentageLinear
} from 'modules/progressBar/slice'
import {SearchProgressPercentage} from 'modules/progressBar/types'
import {Middleware} from 'redux'

import {
  anchorReceived,
  offersReceived,
  offersRequested,
  searchStarted
} from '../slice'

/**
 * Set SRP search progress as we receive data from SAPI
 */
export const searchProgressMiddleware: Middleware =
  ({dispatch}) =>
  next =>
  (action: PayloadAction<object>) => {
    if (searchStarted.match(action)) {
      dispatch(
        setSearchProgressPercentage(SearchProgressPercentage.SearchStarted)
      )
    }
    if (anchorReceived.match(action)) {
      dispatch(
        setSearchProgressPercentageLinear(
          SearchProgressPercentage.AnchorReceived
        )
      )
    }
    if (offersRequested.match(action)) {
      dispatch(
        setSearchProgressPercentageLinear(
          SearchProgressPercentage.HotelsReceived
        )
      )
    }
    if (offersReceived.match(action)) {
      dispatch(
        setSearchProgressPercentageIncrementally(
          SearchProgressPercentage.OffersReceived
        )
      )
    }

    return next(action)
  }
